import { createSlice } from "@reduxjs/toolkit";

import { IUserLoggedEntity } from "@/shared/models/interfaces/entity/user-logged/user-logged.entity";

import type { PayloadAction } from "@reduxjs/toolkit";
// add interface of initial state
// add initial state
// create slices
// export slices
//  create hook for slices
// note import Slice on configure store

type initialStateUserLogged = IUserLoggedEntity | {};
const initialState: initialStateUserLogged = {};

export const UserLoggedSlice = createSlice({
  name: "userLogged",
  initialState,
  reducers: {
    setUserLogged: (state, action: PayloadAction<initialStateUserLogged>) => {
      action.payload;
      return action.payload;
    },

    updateCompleteProfile: (
      state: any,
      action: PayloadAction<{
        isProfileFinished: number;
      }>
    ) => {
      return {
        ...state,
        userData: {
          ...state.userData,
          is_profile_finished: action.payload.isProfileFinished
        }
      } as IUserLoggedEntity;
    },
    clearUserLogged: state => initialState
  }
});

export default UserLoggedSlice;
